import React, { useState, useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useParams } from "react-router-dom";
import { firebase } from "../../Firebase";
import HistoryTable from "../../components/HistoryTable/HistoryTable";
import DetailHeader from "../../components/DetailHeader/DetailHeader";
import BrokenLinksTable from "../../components/BrokenLinksTable/BrokenLinksTable";

function SiteDetailPage() {
  let { url } = useParams();
  const [sites, setSites] = useState([]);
  const [links, setLinks] = useState([]);

  const history = firebase
    .firestore()
    .collection("sites")
    .doc(url)
    .collection("history")
    .orderBy("date", "desc")
    .limit(25);

  const [valueHistory, loadingHistory, errorHistory] = useCollection(history, {
    snapshotListenOptions: { includeMetadataChanges: true }
  });

  useEffect(() => {
    if (valueHistory !== undefined) {
      const newSites = valueHistory.docs.map(doc => doc.data());
      setSites(newSites);
    }
  }, [valueHistory]);

  const linksCollection = firebase
    .firestore()
    .collection("links")
    .doc(url);

  const [valueLinks, loadingLinks, errorLinks] = useCollection(
    linksCollection,
    {
      snapshotListeningOptions: { includeMetadataChanges: true }
    }
  );

  useEffect(() => {
    if (valueLinks !== undefined && valueLinks.data()) {
      setLinks(valueLinks.data().brokenLinks);
    }
  }, [valueLinks, url]);

  const isLoading = loadingHistory || loadingLinks;

  if (errorHistory || errorLinks) {
    return <div className="error">Error loading site</div>;
  }

  return (
    <div>
      {isLoading && <div className="loading">Loading...</div>}
      {!isLoading && (
        <SiteDetailDisplay url={url} sites={sites} links={links} />
      )}
    </div>
  );
}

function SiteDetailDisplay({ url, links, sites }) {
  return (
    <div className="site-detail__container">
      <DetailHeader url={url} />
      <BrokenLinksTable links={links} url={url} />
      <HistoryTable sites={sites} />
    </div>
  );
}

export default SiteDetailPage;
